import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  dashboardCell: {
    position: 'relative',
    height: '100%',
    '&:hover $configButton': {
      opacity: 1,
    },
  },
  configButton: {
    position: 'absolute !important',
    top: '12px',
    right: '12px',
    opacity: 0,
    zIndex: 10,
    transition: 'opacity 0.2s ease, background-color 0.2s, transform 0.2s !important',
    backgroundColor: theme.palette.type === 'dark' ? '#27272A !important' : '#F4F5F7 !important',
    color: `${theme.palette.text.secondary} !important`,
    padding: '6px !important',
    minWidth: 'auto !important',
    borderRadius: '50% !important',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#3F3F46 !important' : '#E4E7EB !important',
      transform: 'rotate(45deg)',
    },
  },
  kpiCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    boxShadow: 'none',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
    },
  },
  kpiHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  kpiIconWrapper: {
    marginRight: theme.spacing(2),
  },
  kpiInfo: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  kpiTitle: {
    fontSize: '0.8rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: '24px',
  },
  kpiTotal: {
    fontSize: '2rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.1,
    marginTop: theme.spacing(0.5),
  },
  kpiDivider: {
    margin: `${theme.spacing(1.5)}px 0`,
    backgroundColor: theme.palette.divider,
  },
  kpiRegionalsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginTop: 'auto',
  },
  regionalBadge: {
    flex: '1 1 0px',
    minWidth: '60px',
    backgroundColor: theme.palette.backGroundItem.cardInterno,
    borderRadius: '8px',
    padding: theme.spacing(1),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#373A40' : 'rgba(10, 37, 64, 0.05)',
    },
  },
  regionalLabel: {
    fontSize: '0.65rem',
    fontWeight: 700,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0.5),
  },
  regionalValue: {
    fontSize: '1rem',
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  statusBadge: {
    flex: '1 1 0px',
    minWidth: '70px',
    borderRadius: '8px',
    padding: theme.spacing(1),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 0.85,
    },
  },
  statusLabel: {
    fontSize: '0.65rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0.5),
  },
  statusValue: {
    fontSize: '1.1rem',
    fontWeight: 700,
  },
  cellLoadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(14, 14, 14, 0.7)' : 'rgba(255, 255, 255, 0.7)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
  },
}))

export default useStyles
